export var EventType;
(function (EventType) {
    EventType["PLAY_BUTTON_CLICK"] = "PLAY_BUTTON_CLICK";
    EventType["BUTTON_CLICK"] = "BUTTON_CLICK";
    EventType["GDPR_BUTTON_CLICK"] = "GDPR_BUTTON_CLICK";
    EventType["LINK_CLICK"] = "LINK_CLICK";
    EventType["GDPR_LINK_CLICK"] = "GDPR_LINK_CLICK";
})(EventType || (EventType = {}));
